export const NAME = 'providers';
export const ADD_PROVIDER_FORM = 'addProviderForm';
export const UPDATE_PROVIDER_FORM = 'updateProviderForm';